import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import {
  Field,
  Input,
  Error,
  Button,
  FormStepCount,
  StepCountText,
  StepCountGraphics,
  Bar,
} from "../styles/form-step-styles";

const Step1 = ({
  errors,
  handleFormStep,
  handleInputChange,
  fullName,
  email,
  phone,
}) => {
  const isIe = detect().name === "ie";

  return (
    <Fragment>
      <FormStepCount className="animated fadeIn delay-2" isIe={isIe}>
        <StepCountText>Step 1/3 - Your Info</StepCountText>
        <StepCountGraphics isIe={isIe}>
          <Bar completed />
          <Bar />
          <Bar />
        </StepCountGraphics>
      </FormStepCount>
      <Field className="animated fadeInLeft delay-3">
        <Input
          type="text"
          name="fullName"
          value={fullName}
          spellCheck={false}
          placeholder="Your full name *"
          data-test-id="employer_intro_full_name"
          onChange={(e) => handleInputChange(e)}
        />
        {errors.fullName && <Error>{errors.fullName}</Error>}
      </Field>
      <Field className="animated fadeInLeft delay-4">
        <Input
          type="email"
          name="email"
          value={email}
          spellCheck={false}
          placeholder="Your work email *"
          data-test-id="employer_intro_email"
          onChange={(e) => handleInputChange(e)}
        />
        {errors.email && <Error>{errors.email}</Error>}
      </Field>
      <Field className="animated fadeInLeft delay-5">
        <Input
          type="phone"
          name="phone"
          value={phone}
          spellCheck={false}
          placeholder="Mobile preferable *"
          data-test-id="employer_intro_phone"
          onChange={(e) => handleInputChange(e)}
        />
        {errors.phone && <Error>{errors.phone}</Error>}
      </Field>
      <Field className="animated fadeInUp delay-5">
        <Button
          data-test-id="employer_intro_next_button"
          onClick={(e) => handleFormStep(e, "forward")}
        >
          Next
        </Button>
      </Field>
    </Fragment>
  );
};

Step1.propTypes = {
  handleFormStep: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    fullName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  fullName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
};

Step1.defaultProps = {
  errors: PropTypes.isNull,
};

export default Step1;
